import callEndpoint from '$src/api/sagas/callEndpoint'
import loginEndpoint, {LoginEndpointArgs} from '$src/api/endpoints/auth/login'
import {IStore} from '$src/bootstrap/Store'
import {getMstStore} from '$src/bootstrap/rootSaga'

export default function* login(args: LoginEndpointArgs): Generator {
  const result = yield callEndpoint(loginEndpoint, args)
  const mstStore: IStore = yield getMstStore()
  mstStore.auth.setAsLoggedIn(result)
}



// WEBPACK FOOTER //
// ./src/auth/sagas/login.ts